import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'; // 1. Redux hooks
import { Button, List } from 'antd';
import { TYPES } from '../reducer'; // 2. Action Types
import { loggerEffect } from '../../effects';
import DB from '../../DAL/DB';
import { auth } from '../../Auth';
import SiteNote from './SiteNote';

const projects = new DB.Projects();

export default function SiteNotes() {
  const dispatch = useDispatch();
  
  // 3. Select project
  const project = useSelector(state => state.project);
  
  const { siteNotes = [] } = project;
  const firstRun = useRef(true);

  const [logger, setLogger] = useState(null);
  
  useEffect(loggerEffect(setLogger, `/projects/${project.id}`), [project.id]);

  useEffect(
    function () {
      if (firstRun.current) {
        firstRun.current = false;
        return;
      }

      (async function () {
        await save();
      })();
    },
    [(project.siteNotes || []).length] // Only runs when a note is added/removed
  );

  async function save() {
    // We use the 'project' from scope, which comes from Redux and is fresh
    await projects.updatebatch(project.id, null, {
      updatedBy: auth?.sunkaizenUser?.id,
      updatedByName: auth?.sunkaizenUser?.name,
      siteNotes: project.siteNotes
    });
  }

  function add() {
    const { id, name } = auth.sunkaizenUser;
    const newNote = { created: new Date(), note: '', authorId: id, author: name };

    // 4. Dispatch Add Action
    dispatch({ type: TYPES.ADD_NOTE, payload: newNote });
  }

  return (
    <div className="flex-column full-width" style={{ textAlign: 'left' }}>
      <div className="padding-1">
        <div className="full-width" style={{ borderTop: '1px solid rgba(220, 220, 220, 1)' }}></div>
      </div>
      <div className="tiny-label">Notes</div>
      {siteNotes.length > 0 && (
        <List 
          dataSource={siteNotes} 
          renderItem={(note, noteKey) => <SiteNote {...{ logger, noteKey, save }} />} 
        />
      )}
      <div className="padding-top-1 flex-row justify-end">
        <Button onClick={add}>Add Note</Button>
      </div>
    </div>
  );
}